export const CREATIVE_TYPE = {
    MOTION: 'MOTION',
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO',
    CREATIVE_TEMPLATE: 'CREATIVE_TEMPLATE',
    DISPLAY: 'DISPLAY',
};
